import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { AiFillCheckCircle } from "react-icons/ai";
import Input from "../Input";

import classes from "./FramePopOverChildren.module.css";

const FramePopOverChildren = ({
  label,
  getter,
  setter,
  galleryArray = [],
  sm = false,
  main_div_flex = false,
  star = false,
}) => {
  return (
    <>
      <div
        className={`${classes.main_div} ${
          main_div_flex && classes?.main_div_flex
        }`}
      >
        <div className={classes?.group}>
          <FormControlLabel
            control={<Checkbox defaultChecked />}
            label={`Show/Hide ${label}`}
            onChange={(e) =>
              setter((p) => ({ ...p, isVisible: e?.target?.checked }))
            }
            checked={getter?.isVisible}
          />
        </div>
        {star && (
          <div className={`${classes?.group} w-100`}>
            <label>Stars [1-5]</label>
            <Input
              type={"number"}
              min={1}
              max={5}
              step={1}
              placeholder={"Star Count [1-5]"}
              value={getter?.count}
              setter={(e) => {
                if (Number(e) > 5 || typeof Number(e) != "number") return;
                setter((p) => ({ ...p, count: e }));
              }}
            />
          </div>
        )}
        {galleryArray?.map((fr, i) => {
          return (
            <div key={i} className={classes?.frameItem}>
              <img
                src={fr}
                className={`${classes?.mainBgImg} ${
                  main_div_flex && classes?.itemSm
                }`}
                draggable={false}
                onClick={() => setter((p) => ({ ...p, url: fr }))}
              />
              {fr === getter?.url && (
                <AiFillCheckCircle
                  className={`${classes?.galleryItemSelected} ${
                    sm && classes?.sm
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default FramePopOverChildren;
